import React from "react";

interface InfoIconProps {
    /** Size in CSS units (e.g. "1em", "16px"). Defaults to 1em. */
    size?: string;
    /** Optional className for styling (e.g. color via currentColor). */
    className?: string;
    /** Accessible label for the icon. Omit when used inside a labeled control (e.g. button). */
    "aria-label"?: string;
}

/**
 * Info icon: serif lowercase "i" with a small dotted line underneath.
 * Use inside buttons or with aria-label for accessibility.
 */
export const InfoIcon: React.FC<InfoIconProps> = ({
    size = "1em",
    className,
    "aria-label": ariaLabel
}) => (
    <svg
        viewBox="0 0 20 20"
        width={size}
        height={size}
        fill="currentColor"
        stroke="none"
        className={className}
        aria-hidden={!ariaLabel}
        aria-label={ariaLabel}
        role={ariaLabel ? "img" : undefined}
    >
        <text
            x="10"
            y="14"
            textAnchor="middle"
            dominantBaseline="alphabetic"
            fontFamily="Georgia, 'Times New Roman', serif"
            fontSize="14"
            fontWeight="normal"
        >
            i
        </text>
        <path
            d="M7 16.5h8"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeDasharray="1.5 1.5"
            strokeLinecap="round"
            fill="none"
        />
    </svg>
);
